var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPerpSwapIcon = function SvgPerpSwapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.257 7.76a.828.828 0 0 0-1.171 1.172l.648.649h-6.32a2.763 2.763 0 0 1-2.76-2.76c0-.633.182-1.253.523-1.786A.827.827 0 0 0 .786 4.14C.272 4.94-.001 5.87 0 6.82a4.42 4.42 0 0 0 4.414 4.414h6.235l-.572.571a.829.829 0 0 0 1.172 1.169l2.017-2.017a.827.827 0 0 0 0-1.169l-2.009-2.028Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.586 2.132H4.8l.751-.751A.829.829 0 0 0 4.38.212L2.363 2.229a.826.826 0 0 0 0 1.169L4.38 5.415a.829.829 0 0 0 1.171-1.169l-.46-.46h6.495a2.763 2.763 0 0 1 2.76 2.76c0 .65-.192 1.285-.552 1.826a.829.829 0 0 0 .692 1.28.823.823 0 0 0 .688-.371c.54-.81.826-1.762.826-2.735a4.42 4.42 0 0 0-4.414-4.414Z"
  })));
};
export default SvgPerpSwapIcon;